const path = window.location.pathname;
const classBase = "blog-nav__link-";

const sections = {
  "/pages/blog": "brand",
  "corpo": "corpo",
  "mente": "mente",
  "nutricao": "nutricao",
};

for (const [key, value] of Object.entries(sections)) {
  if (path.includes(key)) {
    document
      .querySelector(`.${classBase}${value}`)
      ?.classList.add("blog-nav__link--active");
  }
}
